<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-row>
						<el-col :span="20">
							<el-form :inline="true" :model="form" class="demo-form-inline" size="mini">
								<el-form-item label="标题">
									<el-input v-model="form.title"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="getData">查询</el-button>
									<el-button type="danger" @click="clear">清空</el-button>
								</el-form-item>
								<el-form-item>
									<button class="addAll" @click="update('add')">添加广告</button>
								</el-form-item>
							</el-form>
						</el-col>
						<el-col :span="2"></el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-table size="mini" v-loading="loading" element-loading-text="拼命加载中"
								element-loading-spinner="el-icon-loading"
								element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData" style="width: 100%"
								border :header-cell-style="{background:'#E5E7EE',color:'#000000'}" ref="multipleTable"
								@selection-change="handleSelectionChange" row-key="id">
								<el-table-column type="selection" width="55" align="center">
								</el-table-column>
								<!-- <el-table-column prop="id" label="编号" align="center" width="55">
								</el-table-column>
								<el-table-column prop="title" label="广告标题" align="left">
								</el-table-column> -->
								<el-table-column :prop="dropCol[index].prop" :label="item.label" align="left"
									v-for="(item,index) in col" :key="`col_${index}`">
								</el-table-column>
								<el-table-column prop="contents" label="广告内容" align="left" width="250px">
									<template slot-scope="scope">
										<p class="contents">{{scope.row.contents}}</p>
									</template>
								</el-table-column>
								<el-table-column prop="img" label="广告图片" align="center">
									<template slot-scope="scope">
										<img style="width: 80px; height: 80px" :src="settings.apiBaseImg+scope.row.img"
											@click="preview(scope.row.img)">
									</template>
								</el-table-column>
								<el-table-column prop="path" label="跳转链接" align="center">
								</el-table-column>
								<el-table-column prop="sType" label="广告类别" align="center">
								</el-table-column>
								<el-table-column prop="mark" label="标识" align="center">
								</el-table-column>
								<el-table-column prop="status" label="置顶" align="center" :formatter="getStatus">
									<template slot-scope="scope">
										<el-switch @change="updateTop(scope.$index,scope.row)"
											v-model="scope.row.status" active-color="#13ce66" inactive-color="#dcdfe6"
											:active-value="1" :inactive-value="0">
										</el-switch>
									</template>
								</el-table-column>
								<el-table-column fixed="right" label="操作">
									<template slot-scope="scope">
										<!-- <el-button @click.native.prevent="update('update',scope.row)" type="text" size="small">编辑</el-button>
										<span>|</span>
										<el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small">
											删除
										</el-button> -->
										<el-button type="success" icon="el-icon-edit" circle size="small"
											@click.native.prevent="update('update',scope.row)"></el-button>
										<el-button type="danger" icon="el-icon-delete" circle
											@click.native.prevent="deleteRow(scope.$index,scope.row)" size="small">
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="tableFooter">
								<button class="selectAll" style="float: left;"
									@click="toggleSelection(tableData)">全选</button>
								<input type="button" class="del" value="批量删除" @click="selectDel" style="float: left;">
							</div>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		<fox-preview-image v-model="visiable" :src="srcList" z-index="9000"></fox-preview-image>
	</div>
</template>

<script>
	import request from '../../assets/js/request.js'
	import Sortable from 'sortablejs'
	import qs from 'qs'
	export default {
		data() {
			return {
				form: {
					title: ''
				},
				col: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '广告标题',
						prop: 'title'
					},
				],
				dropCol: [{
						label: '编号',
						prop: 'id'
					},
					{
						label: '广告标题',
						prop: 'title'
					},
				],
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				multipleTable: [],
				loading: false,
				srcList: '',
				visiable: false
			}
		},
		created() {
			this.getData(this.currentPage, this.pageSize)
		},
		mounted() {
			this.rowDrop()
		},
		methods: {
			// 行拖拽
			rowDrop() {
				const tbody = document.querySelector('.el-table__body-wrapper tbody')
				const _this = this
				Sortable.create(tbody, {
					onEnd({
						newIndex,
						oldIndex
					}) {
						const currRow = _this.tableData.splice(oldIndex, 1)[0]
						_this.tableData.splice(newIndex, 0, currRow)
					}
				})
			},
			preview(rows) {
				this.visiable = true
				this.srcList = ''
				this.srcList = this.settings.apiBaseImg + rows
			},
			getStatus(row, column) {
				return row.status == 1 ? true : false
			},
			clear() {
				this.form.title = ''
				this.getData(this.currentPage, this.pageSize)
			},
			//获取列表数据
			getData(currentPage, pageSize) {
				this.loading = true
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/adver/page',
					params: {
						title: this.form.title,
						pageNum: currentPage,
						pageSize: pageSize
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.message)
					}
				})

			},
			//修改
			update(iden, rows) {
				this.$router.push({
					path: '/home/update',
					query: {
						iden: iden,
						rows: rows
					}
				})
			},
			//删除
			deleteRow(index, rows) {
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/adver/clear',
						params: {
							ids: rows.id,
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})

				}).catch(() => {
					this.loading = false
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//批量删除
			selectDel() {

				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				var list = []
				for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
					list.push(this.$refs.multipleTable.selection[i].id)
				}
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.loading = true
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/adver/clear',
						params: {
							ids: list.toString(),
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 200) {
							this.loading = false
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.message)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			//全选
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//修改置顶
			updateTop(index, rows) {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/adver/change/status',
					params: {
						id: rows.id,

						status: rows.status == true ? 1 : 0
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						obj.$message.success('修改成功')
						this.getData(this.currentPage, this.pageSize)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},

		},
	}
</script>

<style scoped="scoped">
	/deep/.el-form-item__label {
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
	}

	/deep/.el-button--text {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	h4 {
		margin-bottom: 20px;
	}

	.contents {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/advertManage.vue